import PropTypes from 'prop-types';
import evolve from 'ramda/es/evolve';
import React from 'react';
import { Formik } from 'formik';

// Formik doesn't provide a way to use onBlur or onChange to trigger value changes
// so we inject that functionality here using their validation feature.
export default class FormWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.formikRef = React.createRef();
  }

  // override props.validate to inject transformation of our values.
  // note: data transformation happens before validation.
  validate = (values) => {
    const { validate, transformationSchema } = this.props;

    let newValues = values;

    if (this.formikRef.current && transformationSchema) {
      newValues = evolve(transformationSchema, values);
      // preprocess fields
      this.formikRef.current.setValues(newValues);
    }

    // run/return this.props.validate
    if (typeof validate === 'function') {
      return validate(newValues);
    }
  };

  render() {
    const {
      initialValues,
      validationSchema,
      onSubmit,
      component,
      validateOnBlur,
      validateOnChange,
      ...additionalProps
    } = this.props;

    return (
      <Formik
        innerRef={this.formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnBlur={validateOnBlur}
        validateOnChange={validateOnChange}
        {...additionalProps}
        validate={this.validate} //after additional props to override 'validate'
      >
        {(formProps) => (component ? component(formProps) : null)}
      </Formik>
    );
  }
}

FormWrapper.propTypes = {
  initialValues: PropTypes.object,
  validationSchema: PropTypes.object,
  onSubmit: PropTypes.func,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  additionalProps: PropTypes.object,
  validate: PropTypes.func,
  transformationSchema: PropTypes.object, // map keys to transformation functions
};
